import React from 'react';
import Loader from './Loader';
import { useLoaderContext } from './LoaderContext';

const GlobalLoader = () => {
  const { loader, setLoader } = useLoaderContext();

  return (
    <>
      <Loader loader={loader} setLoader={setLoader} />
    </>
  );
};

export default GlobalLoader;
